import helpers from '../util/helpers';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // Most search slider
    let destinationSliderIsSwiping = false;

    const mostSearchSlider = $('.section-destinations-slider .slider');
    if (mostSearchSlider.length) {
      mostSearchSlider.on('init', function() {
        helpers.equalHeightElements('.section-destinations-slider .slider .equal-height');
      });

      mostSearchSlider.slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        variableWidth: true,
        swipeToSlide: true,
        prevArrow: $('.section-destinations-slider .prev'),
        nextArrow: $('.section-destinations-slider .next'),
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });

      mostSearchSlider.on('beforeChange', () => {
        destinationSliderIsSwiping = true;
      });

      mostSearchSlider.on('afterChange', () => {
        destinationSliderIsSwiping = false;
      });
    }

    // Global destinations slider click
    const destinationSlider = $('.section-destinations-slider');
    if (destinationSlider.length) {
      const destinationsClicked = (destinationName) => {
        // Set for select2
        const globalOfferLocationsFilter = $('#evt-global-offer-locations-filter');

        if (globalOfferLocationsFilter.length && globalOfferLocationsFilter.find('option[value="' + destinationName + '"]').length) {
          globalOfferLocationsFilter.val(destinationName).trigger('change').trigger('select2:select');

          const globalOfferWrapper = $('#evt-global-offers-wrapper');
          if (globalOfferWrapper.length) {
            globalOfferWrapper.goToElement();
          }
        }
      };

      const destinations = destinationSlider.find('.single-destination');

      destinations.each(function() {
        const _this = $(this);
        const dataDestination = _this.data('destination');

        _this.on('click', () => {
          if (destinationSliderIsSwiping) {
            return;
          }

          destinationsClicked(dataDestination);
        });
      });
    }

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleCptOffer.js